
export default {
  name: 'rzIconArrow',
  props: {
    contrastColor: Boolean,
    left: Boolean,
  },
  computed: {
    modifierClasses() {
      return {
        'icon-arrow--contrast-color': this.contrastColor,
        'icon-arrow--left': this.left,
      };
    },
  },
};
